import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7abdacf8"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["id"];
const _hoisted_2 = ["onClick"];
const _hoisted_3 = ["innerHTML"];
import { onClickOutside } from '@vueuse/core';
import { onBeforeUnmount, onMounted, ref } from 'vue';
import { useStore } from '../store';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ContextMenu',
    props: {
        elementId: {},
        options: {}
    },
    emits: ["option-clicked"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const state = useStore();
        const contentMenuRef = ref();
        const item = ref(null);
        const menuWidth = ref(null);
        const menuHeight = ref(null);
        const showMenu = (event, payload) => {
            item.value = payload;
            const menu = document.getElementById(props.elementId);
            if (!menu) {
                return;
            }
            if (!menuWidth.value || !menuHeight.value) {
                menu.style.visibility = 'hidden';
                menu.style.display = 'block';
                menuWidth.value = menu.offsetWidth;
                menuHeight.value = menu.offsetHeight;
                menu.removeAttribute('style');
            }
            if (menuWidth.value + event.pageX >= window.innerWidth) {
                menu.style.left = event.pageX - menuWidth.value + 2 + 'px';
            }
            else {
                if (state.mediaModal) {
                    menu.style.left = event.pageX - 52 + 'px';
                }
                else {
                    menu.style.left = event.pageX - 2 + 'px';
                }
            }
            if (menuHeight.value + event.pageY >= window.innerHeight) {
                menu.style.top = event.pageY - menuHeight.value + 2 + 'px';
            }
            else {
                if (state.mediaModal) {
                    menu.style.top = event.pageY - 152 + 'px';
                }
                else {
                    menu.style.top = event.pageY - 2 + 'px';
                }
            }
            menu.classList.add('vue-simple-context-menu--active');
        };
        const hideContextMenu = () => {
            const element = document.getElementById(props.elementId);
            if (element) {
                element.classList.remove('vue-simple-context-menu--active');
            }
        };
        const optionClicked = (option) => {
            if (option.disabled)
                return;
            hideContextMenu();
            emit('option-clicked', {
                item: item.value,
                option: option,
            });
        };
        const onEscKeyRelease = (event) => {
            if (event.keyCode === 27) {
                hideContextMenu();
            }
        };
        onMounted(() => {
            document.body.addEventListener('keyup', onEscKeyRelease);
        });
        onBeforeUnmount(() => {
            document.removeEventListener('keyup', onEscKeyRelease);
        });
        onClickOutside(contentMenuRef, hideContextMenu);
        __expose({
            showMenu,
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("ul", {
                    id: _ctx.elementId,
                    class: "vue-simple-context-menu",
                    ref_key: "contentMenuRef",
                    ref: contentMenuRef
                }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
                        return (_openBlock(), _createElementBlock("li", {
                            key: index,
                            onClick: _withModifiers(($event) => (optionClicked(option)), ["stop"]),
                            class: _normalizeClass(["vue-simple-context-menu__item", [
                                    option.class,
                                    option.type === 'divider' ? 'vue-simple-context-menu__divider' : '',
                                    option.disabled ? 'disabled-item' : '',
                                ]])
                        }, [
                            (option.icon)
                                ? (_openBlock(), _createBlock(_resolveDynamicComponent(option === null || option === void 0 ? void 0 : option.icon()), { key: 0 }))
                                : _createCommentVNode("v-if", true),
                            _createElementVNode("span", {
                                class: "ml-2",
                                innerHTML: option.name
                            }, null, 8 /* PROPS */, _hoisted_3)
                        ], 10 /* CLASS, PROPS */, _hoisted_2));
                    }), 128 /* KEYED_FRAGMENT */))
                ], 8 /* PROPS */, _hoisted_1)
            ]));
        };
    }
});
